<!--
  If only 10 options are present, go with select box in both mail and mobile
  If more than 10 options are present and step > 2, go with text box alone and with step icons
  else show both text box and select box
!-->

<template>
  <div class="cb-item__quantity">
    <template v-if="type">
      <div class="cb-item__quantity cb-item__quantity--active">
        <div class="cb-item__steper" v-if="type == 'range' && optionsMoreThan10" :class="{'cb-qty-extender': shouldExpandComponent}">
          <input ref="quantity" class="cb-item__control cb-quantity-no-moz-appearance" :class="{'cb-qty-extender': shouldExpandComponent, 'cb-item__control--sm': shouldReduceFont}" type="number" min="1" pattern="[0-9]*" :value="quantity || meta.min" @keyup.enter="updateQuantityCloseOptions($event.target.value)" @blur="updateQuantity($event.target.value)" data-cb-id="item_quantity" @focus="showHelpText = true"/>
          <div class="cb-item__icons">
            <div class="cb-item__icon" @click="incrementStep()" :class="{'cb-item__icon--disabled' : disableIncrement}">&#43;</div>
            <div class="cb-item__icon cb-item__icon--lg" :class="{'cb-item__icon--disabled' : disableDecrement}" @click = "decrementStep()">&#45;</div>
          </div>
        </div>
        <div class="cb-item__select" v-else>
          <select ref="select" class="cb-item__control cb-item__control--select cb-quantity-no-moz-appearance" :class="{'cb-item__control--sm': shouldReduceFont, 'cb-qty-extender': shouldExpandComponent}" v-model.number="internalQuantity">
            <option v-for="(qty, index) in qtyOptions" :value="qty" v-bind:key="index">
              <span>{{ qtyLabel }} {{ qty }}</span>
            </option>
          </select>
        </div>
      </div>
    </template>
    <template v-else>
      <div ref="x" class="cb-item__quantity" :class="{'cb-item__quantity--active': inputMode}" @click="toggleInputMode($event)" @keyup.up="showInputMode($event)" @keyup.down="showInputMode($event)" tabindex="0" :style="shadowColor" role="listbox">
        <div ref="inputContainer" class="cb-item__placeholder" :class="{'cb-item__placeholder--compress': shouldReduceFont, 'cb-qty-extender': shouldExpandComponent}">
          <span v-if="shouldShowQtyLabel">{{ qtyLabel }}</span> {{ quantity || 1}}
        </div>
        <input ref="quantity" class="cb-item__control cb-quantity-no-moz-appearance" :class="{'cb-qty-extender': shouldExpandComponent, 'cb-item__control--sm': shouldReduceFont}" type="number" min="1" pattern="[0-9]*" :value="quantity || 1" @keyup.enter="updateQuantityCloseOptions($event.target.value)" @blur="updateQuantity($event.target.value)" data-cb-id="item_quantity"/>
      </div>
    </template>
    <transition name="scale-down-y">
      <div ref="dropdownContainer" class="cb-item__options" v-show="inputMode" :class="{'cb-item__options--top': position, 'cb-qty-extender': shouldExpandComponent}">
        <div tabindex="0" v-bind:key="qty" class="cb-item__option" @keyup.enter="updateQuantityCloseOptions(qty)" @keyup.down = "navigateDown($event)" @keyup.up="navigateUp($event)"  v-for="qty in qtyOptions" @click="updateQuantity(qty)" role="listitem">
          {{ qty }}
        </div>
      </div>
    </transition>
    <!-- <transition name="help-text">
      <div class="cb-item__menu" v-if="showHelpText">Help text goes here
      </div>
    </transition> -->
    <cb-slide-n-fade>
      <div class="cb-text__error cb-transitioin__slide" v-if="errorMessage">
        {{errorMessage}}
      </div>
    </cb-slide-n-fade>
  </div>
</template>
<script>
import {
  mapGetters
} from 'vuex'
import CBNotification from "@/models/cb-notification"
export default {
  data() {
    return {
      inputMode: false,
      position: false,
      disableIncrement: false,
      disableDecrement: false,
      showHelpText:false,
      errorMessage: "",
      optionsMoreThan10: false,
      qtyLabelLength: 0
    }
  },
  props: {
    quantity: Number,
    meta: [Object, Boolean],
    initialQuantity: Number
  },
  computed: {
    type(){
      return this.meta && this.meta.type;
    },
    qtyLabel() {
      return this.t("qty");
    },
    internalQuantity: {
      set(value) {
        this.updateQuantity(value);
      },
      get() {
        return this.quantity;
      }
    },
    shouldExpandComponent() {
      const qtyLength = this.quantity ? this.quantity.toString().length : 1;
      const totalLength = qtyLength + this.qtyLabelLength;
      return totalLength > 8;
    },
    shouldReduceFont() {
      const qtyLength = this.quantity ? this.quantity.toString().length : 1;
      const totalLength = qtyLength + this.qtyLabelLength;
      return this.shouldExpandComponent ? totalLength > 12 : totalLength > 5;
    },
    shouldShowQtyLabel() {
      const qtyLength = this.quantity ? this.quantity.toString().length : 1;
      return qtyLength < 5;
    },
    qtyOptions() {
      // Computed value of quantity options
      return this.genQtyOptions();
    }
  },
  watch: {
    qtyLabel: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.qtyLabelLength = newVal.length;
        }
      }
    }
  },
  mounted(){
    this.qtyOptions = this.genQtyOptions();
    if(this.type) {
      let resetToInitialValue = this.type == "range" ? !this.allowedInRange(this.quantity) : this.qtyOptions.indexOf(this.quantity) == -1;
      if(resetToInitialValue) {
         window.setTimeout(() => {
          this.updateQuantity(this.qtyOptions[0]);
        });
      }
    }
  },
  methods: {
     toggleInputMode($event) {
      this.calculatePosition();
      this.inputMode = !this.inputMode;
      if (this.inputMode) {
        this.$nextTick(() => {
          this.$refs.quantity.focus();
          window.cbTimeout(() => document.addEventListener('click', this.closeDropDown));
        });
      } else {
        document.removeEventListener('click', this.closeDropDown);
      }
    },
    showInputMode() {
      this.calculatePosition();
      this.inputMode = true;
      if (this.inputMode) {
        this.$nextTick(() => {
          this.$refs.quantity.focus();
          window.cbTimeout(() => document.addEventListener('click', this.closeDropDown));
        });
      } else {
        document.removeEventListener('click', this.closeDropDown);
      }
    },
    navigateDown($event){
      if($event.target && $event.target.nextElementSibling)
        $event.target.nextElementSibling.focus();
    },
    navigateUp($event){
      if($event.target && $event.target.previousElementSibling)
        $event.target.previousElementSibling.focus();
    },
    updateQuantityCloseOptions(value) {
      this.updateQuantity(value);
      this.closeDropDown();
    },
    calculatePosition() {
      var _this = this.$refs.x;
      var appHeight = document.getElementById("app").offsetHeight;
      if (appHeight - _this.getBoundingClientRect().top < 150) {
        this.position = true;
        this.$refs.dropdownContainer.style.bottom = _this.clientHeight + "px";
        this.$refs.dropdownContainer.style.top = "auto";
      } else {
        this.position = false;
        this.$refs.dropdownContainer.style.top = _this.clientHeight + "px";
        this.$refs.dropdownContainer.style.bottom = "auto";
      }
    },
    closeDropDown(event) {
      this._closeDropDown();
    },
    _closeDropDown() {
      if (this.inputMode) {
        this.inputMode = false;
      }
      document.removeEventListener('click', this.closeDropDown);
    },
    checkForLimit(value){
      this.disableDecrement = this.disableIncrement = false;
      return (value <= this.meta.min && (this.disableDecrement = true)) ||
      (value + this.meta.step >= this.meta.max && (this.disableIncrement = true));
    },
    allowedInRange(value) {
      if(this.type == "range") {
        return value >= this.meta.min && value <= this.meta.max && ((value - this.meta.min) % this.meta.step == 0);
      }
      return false;
    },
    updateQuantity(value) {
      value = parseInt(value);
      this.errorMessage = "";
      this.showHelpText = false;
      if(this.type == 'range' && !this.allowedInRange(value)){
        // this._displayErrorMessage('Please enter a valid value in the range(' + this.meta.min + ',' + this.meta.max + ')' + ' with a step value of ' + this.meta.step );
        this.errorMessage = this.meta.step > 1 ? `Please enter a value within the range (${this.meta.min}, ${this.meta.max}) in the multiples of ${this.meta.step}` : `Please enter a value within the range (${this.meta.min}, ${this.meta.max})`;
        return;
      }
      if(value < this.initialQuantity) {
        this.errorMessage = `Please enter a value greater than ${this.initialQuantity}`;
        return;
      }
      this.type == 'range' && this.checkForLimit(value);
      this.$emit("input", value);
    },
    genQtyOptions() {
      let output = [];
      switch(this.meta && this.meta.type) {
        case "fixed":
          output = this.meta.values.map((v) => parseInt(v)).filter(i => i > this.initialQuantity);
          break;
        case "range":
          let min = this.initialQuantity != 0 ? this.initialQuantity : (this.meta.min || 1);
          let max = this.meta.max || 1;
          let step = this.meta.step || 1;
          let rangeOutput = window.range10(min, max, step);
          output = rangeOutput.array;
          this.optionsMoreThan10 = rangeOutput.moreThan10;
          break;
        default:
          let initialQuantity = this.initialQuantity != 0 ? this.initialQuantity : 1;
          output = window.range10(initialQuantity, initialQuantity + 10, 1).array;
      }
      return output;
    },
    incrementStep(){
      let step = this.meta.step || 1;
      if(!(this.meta && step)){
        return;
      }
      step = parseInt(this.$refs.quantity.value) + step;
      (step <= this.meta.max) && this.updateQuantity(step);
    },
    decrementStep(){
      let step = this.meta.step || 1;
      if(!(this.meta && step)){
        return;
      }
      step = parseInt(this.$refs.quantity.value) - step;
      (step >= this.meta.min) && this.updateQuantity(step);
    },
    _displayErrorMessage(msg) {
      this.$store.dispatch('set_current_notification', new CBNotification('error', {message: msg, isDismissible: true}))
      .then(() => {
        this.$refs.quantity.value = this.quantity || this.meta.min;
      });
    }
  }
}
</script>
<style  lang="stylus" scoped>
.cb-cart--multiple .cb-item__control.cb-item__control--sm {
  font-size: 9px;
}

input[type='number'], 
.cb-item__control, 
.cb-item__control:hover,
.cb-item__control:focus{
    -moz-appearance: textfield;
}
.cb-quantity-no-moz-appearance {
  -moz-appearance: none;
  text-indent: 0px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button,
.cb-item__control::-webkit-outer-spin-button:hover, 
.cb-item__control::-webkit-inner-spin-button:hover,
.cb-item__control::-webkit-outer-spin-button:focus, 
.cb-item__control::-webkit-inner-spin-button:focus {
    -webkit-appearance: none;
}

.cb-qty-extender {
  width: 150px;
}
</style>
